import { Component, OnInit, PLATFORM_ID, ChangeDetectionStrategy, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentPage } from '../../models';
import { Store } from '@ngrx/store';
import { ContentState } from '../../store';
import { isPlatformBrowser, AsyncPipe } from '@angular/common';
import * as selectors from '../../store/selectors/content-pages.selector';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { CookiePreferences, getCookiePreferences, CookieListenerDirective, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { HeaderArticleComponent } from '../../../core/components/header-article/header-article.component';
import { BreadcrumbsComponent } from '../../../core/components/breadcrumbs/breadcrumbs.component';
import { ContentBlockContainerComponent } from '../../../content-blocks/containers/content-block-container/content-block-container.component';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderArticleComponent,
    BreadcrumbsComponent,
    CookieListenerDirective,
    ContentBlockContainerComponent,
    AsyncPipe,
    SafePipe,
    StripEmbedPipe,
  ],
})
export class ContentPageComponent implements OnInit {
  private store = inject<Store<ContentState>>(Store);

  cookiesAccepted$!: Observable<CookiePreferences | null>;
  page$!: Observable<ContentPage>;
  breadcrumbs: Breadcrumb[] = [
    {
      label: "Pagina's",
      routerLink: ['/page'],
    },
  ];

  ngOnInit(): void {
    this.page$ = this.store.select(selectors.getSelectedContentPage);
    this.cookiesAccepted$ = this.store.select(getCookiePreferences);
  }
}
